<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">Historical Info</h4>
                                <h5 class="card-subtitle">Overview of Latest Month</h5>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <date-range-picker
                                        :opens="opens"
                                        :startDate="startDate"
                                        :endDate="endDate"
                                        @update="updateValues"
                                        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }"
                                        :minDate="minDate" :maxDate="maxDate">
                                    <div slot="input" slot-scope="picker">
                                        {{ picker.startDate | date }} - {{ picker.endDate | date }}
                                    </div>
                                </date-range-picker>
                            </div>
                        </div>

                        <v-chart :options="options" auto-resize/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import ECharts from 'vue-echarts/components/ECharts'
    import echarts from 'echarts/lib/echarts'
    import 'echarts/lib/chart/bar'
    import 'echarts/lib/chart/line'
    import 'echarts/lib/component/tooltip'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/component/title'
    import 'echarts/lib/component/dataZoom'
    import moment from "moment";

    let base      = +new Date(1968, 9, 3);
    let oneDay    = 24 * 3600 * 1000;
    let date      = [];
    let chartData = [Math.random() * 300];

    for(let i = 1; i < 20000; i++) {
        let now = new Date(base += oneDay);
        date.push([now.getFullYear(), now.getMonth() + 1, now.getDate()].join('/'));
        chartData.push(Math.round((Math.random() - 0.5) * 20 + chartData[i - 1]));
    }

    export default {
        name: "HistorialInfo",
        components: {
            'v-chart': ECharts,
            DateRangePicker
        },
        data: function() {
            return {
                options: {
                    dataset: {
                        source: chartData
                    },
                    tooltip: {
                        trigger: 'axis',
                        position: function(pt) {
                            return [pt[0], '10%'];
                        }
                    },
                    title: {
                        left: 'center',
                    },
                    toolbox: {
                        feature: {
                            dataZoom: {
                                yAxisIndex: 'none'
                            },
                            restore: {},
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: date
                    },
                    yAxis: {
                        type: 'value',
                        boundaryGap: [0, '100%']
                    },
                    dataZoom: [{
                        type: 'inside',
                        start: 0,
                        end: 10
                    }, {
                        start: 0,
                        end: 10,
                        handleIcon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                        handleSize: '80%',
                        handleStyle: {
                            color: '#fff',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    }],
                    series: [
                        {
                            name: 'Price',
                            type: 'line',
                            smooth: true,
                            symbol: 'none',
                            sampling: 'average',
                            itemStyle: {
                                color: 'rgb(56, 142, 60)'
                            },
                            areaStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                    offset: 0,
                                    color: 'rgb(56, 142, 60)'
                                }, {
                                    offset: 1,
                                    color: 'rgb(139, 195, 74)'
                                }])
                            },
                            data: chartData
                        }
                    ]
                },
                opens: 'center',
                startDate: '2017-09-19',
                endDate: '2017-10-09',
                minDate: '2017-09-02',
                maxDate: '2017-10-02',
            }
        },
        filters: {
            date (value) {
                let options = {year: 'numeric', month: 'long', day: 'numeric'};
                return Intl.DateTimeFormat('en-US', options).format(value)
            }
        },
        methods: {
            updateValues(values) {
                console.log(values)
                this.startDate = values.startDate.toISOString().slice(0, 10)
                this.endDate   = values.endDate.toISOString().slice(0, 10)
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 600px;
    }
</style>